/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
import Component from "./Component";
import ComponentEvent from "./ComponentEvent";

export { ComponentEvent };
export default Component;
